import Dragger from "antd/es/upload/Dragger.js";
import { useResponsive } from "../../hooks/useResponsive.js";

const KycRequested = ({ kycDetails }) => {
  const { isMobile } = useResponsive();

  const isPdfFile = (url) => {
    return url?.toLowerCase().endsWith(".pdf");
  };

  const openPdf = (url) => {
    if (url) {
      window.open(url, "_blank", "noopener,noreferrer");
    }
  };

  return (
    <div className="kyc-container">
      <div className="container">
        <div className="w-full min-h-[calc(100vh-200px)] flex flex-col items-center justify-center p-5">
          <div className="mb-9">
            <p className="font-bold text-[#2F2B3D] sm:text-4xl text-xl text-center">
              Your KYC is under proccess...
            </p>
            <p className="mt-4 text-center">
              Please wait your kyc request has been pending.
            </p>
          </div>

          {kycDetails && (
            <div
              className={`flex ${
                isMobile ? "flex-col" : "flex-row"
              } gap-3 w-full max-w-6xl`}
            >
              {/* ID Proof Section */}
              <div className="border border-gray-300 rounded-md p-5 flex-1">
                <p className="text-[#2F2B3D] text-2xl text-center mb-3">
                  ID Proof
                </p>
                <p className="text-gray-500 text-base text-center mb-3">
                  Uploaded documents for verification
                </p>

                <div className="flex md:flex-nowrap flex-wrap lg:gap-6 gap-3 justify-center">
                  {/* Front Side */}
                  <div className="mb-3">
                    <Dragger
                      disabled={true}
                      showUploadList={false}
                      beforeUpload={() => false}
                      className="front-upload"
                    >
                      <div className="w-full h-full">
                        {kycDetails?.fileUrlPath?.[0] ? (
                          <div className="relative flex justify-center items-center">
                            {isPdfFile(kycDetails.fileUrlPath[0]) ? (
                              <div className="rounded-lg w-[300px] h-[190px] sm:h-[200px] sm:w-[345px] bg-gray-100 flex flex-col items-center justify-center text-gray-700 gap-2">
                                PDF
                                <button
                                  type="button"
                                  className="text-primary underline text-sm"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    openPdf(kycDetails.fileUrlPath[0]);
                                  }}
                                >
                                  View PDF
                                </button>
                              </div>
                            ) : (
                              <img
                                src={kycDetails.fileUrlPath[0]}
                                alt="front"
                                className="rounded-lg w-[300px] h-[190px] sm:h-[200px] sm:w-[345px] object-contain"
                              />
                            )}
                          </div>
                        ) : (
                          <div className="flex justify-center flex-col items-center md:py-4 md:px-5">
                            <p className="text-gray-400">
                              Front side not available
                            </p>
                          </div>
                        )}
                      </div>
                    </Dragger>
                  </div>

                  {/* Back Side */}
                  <div className="mb-3">
                    <Dragger
                      disabled={true}
                      showUploadList={false}
                      beforeUpload={() => false}
                      className="back-upload"
                    >
                      <div className="w-full h-full">
                        {kycDetails?.fileUrlPath?.[1] ? (
                          <div className="relative flex justify-center items-center">
                            {isPdfFile(kycDetails.fileUrlPath[1]) ? (
                              <div className="rounded-lg w-[300px] h-[190px] sm:h-[200px] sm:w-[345px] bg-gray-100 flex flex-col items-center justify-center text-gray-700 gap-2">
                                PDF
                                <button
                                  type="button"
                                  className="text-primary underline text-sm"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    openPdf(kycDetails.fileUrlPath[1]);
                                  }}
                                >
                                  View PDF
                                </button>
                              </div>
                            ) : (
                              <img
                                src={kycDetails.fileUrlPath[1]}
                                alt="back"
                                className="rounded-lg w-[300px] h-[190px] sm:h-[200px] sm:w-[345px] object-contain"
                              />
                            )}
                          </div>
                        ) : (
                          <div className="flex justify-center flex-col items-center md:py-4 md:px-5">
                            <p className="text-gray-400">
                              Back side not available
                            </p>
                          </div>
                        )}
                      </div>
                    </Dragger>
                  </div>
                </div>
              </div>

              {/* Address Proof Section */}
              <div className="border border-gray-300 rounded-md p-5 flex-1">
                <p className="text-[#2F2B3D] text-2xl text-center mb-3">
                  Address Proof
                </p>
                <p className="text-gray-500 text-base text-center mb-3">
                  Uploaded documents for verification
                </p>

                <div className="flex md:flex-nowrap flex-wrap lg:gap-6 gap-3 justify-center">
                  {/* Front Side */}
                  <div className="mb-3">
                    <Dragger
                      disabled={true}
                      showUploadList={false}
                      beforeUpload={() => false}
                      className="address-proof-front-upload"
                    >
                      <div className="w-full h-full">
                        {kycDetails?.addressUrlPath?.[0] ? (
                          <div className="relative flex justify-center items-center">
                            {isPdfFile(kycDetails.addressUrlPath[0]) ? (
                              <div className="rounded-lg w-[300px] h-[190px] sm:h-[200px] sm:w-[345px] bg-gray-100 flex flex-col items-center justify-center text-gray-700 gap-2">
                                PDF
                                <button
                                  type="button"
                                  className="text-primary underline text-sm"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    openPdf(kycDetails.addressUrlPath[0]);
                                  }}
                                >
                                  View PDF
                                </button>
                              </div>
                            ) : (
                              <img
                                src={kycDetails.addressUrlPath[0]}
                                alt="address-proof-front"
                                className="rounded-lg w-[300px] h-[190px] sm:h-[200px] sm:w-[345px] object-contain"
                              />
                            )}
                          </div>
                        ) : (
                          <div className="flex justify-center flex-col items-center md:py-4 md:px-5">
                            <p className="text-gray-400">
                              Front side not available
                            </p>
                          </div>
                        )}
                      </div>
                    </Dragger>
                  </div>

                  {/* Back Side */}
                  <div className="mb-3">
                    <Dragger
                      disabled={true}
                      showUploadList={false}
                      beforeUpload={() => false}
                      className="address-proof-back-upload"
                    >
                      <div className="w-full h-full">
                        {kycDetails?.addressUrlPath?.[1] ? (
                          <div className="relative flex justify-center items-center">
                            {isPdfFile(kycDetails.addressUrlPath[1]) ? (
                              <div className="rounded-lg w-[300px] h-[190px] sm:h-[200px] sm:w-[345px] bg-gray-100 flex flex-col items-center justify-center text-gray-700 gap-2">
                                PDF
                                <button
                                  type="button"
                                  className="text-primary underline text-sm"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    openPdf(kycDetails.addressUrlPath[1]);
                                  }}
                                >
                                  View PDF
                                </button>
                              </div>
                            ) : (
                              <img
                                src={kycDetails.addressUrlPath[1]}
                                alt="address-proof-back"
                                className="rounded-lg w-[300px] h-[190px] sm:h-[200px] sm:w-[345px] object-contain"
                              />
                            )}
                          </div>
                        ) : (
                          <div className="flex justify-center flex-col items-center md:py-4 md:px-5">
                            <p className="text-gray-400">
                              Back side not available
                            </p>
                          </div>
                        )}
                      </div>
                    </Dragger>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default KycRequested;
